import { IComparator, NameValue } from '@infodata-group/inf-commons';

export class Journal implements IComparator {
  public account: string;
  public active: NameValue = new NameValue('', '');
  public code: string;
  public label: string;
  public openPost: NameValue = new NameValue('', '');
  public operationType: string;
  public vat: NameValue = new NameValue('', '');

  convert(item: any): Journal {
    const journal = new Journal();
    journal.account = item.Account;
    journal.active.name = item.Active?.Id;
    journal.active.value = item.Active?.Label;
    journal.code = item.Code;
    journal.label = item.Label;
    journal.openPost.name = item.OpenPost?.Id;
    journal.openPost.value = item.OpenPost?.Label;
    journal.operationType = item.OperationType;
    journal.vat.name = item.Tva?.Id;
    journal.vat.value = item.Tva?.Label;
    return journal;
  }

  toString() {
    return `${this.label}`;
  }
  compare(comparant: any): number {
    return this.code === comparant.code ? 0 : 1;
  }
}
